import { render, staticRenderFns } from "./exhibitorsMobile.vue?vue&type=template&id=29b2037e&scoped=true"
import script from "./exhibitorsMobile.vue?vue&type=script&lang=js"
export * from "./exhibitorsMobile.vue?vue&type=script&lang=js"
import style0 from "./exhibitorsMobile.vue?vue&type=style&index=0&id=29b2037e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b2037e",
  null
  
)

export default component.exports